module.exports = __webpack_public_path__ + "img/default_thumbnail.092b9902.png";